import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ModuleConfiguration } from '../submission.module.config';
import * as pillarActions from '../../pillar/dashboard/store/actions';
import { JobsService } from './JobsService';
import { JobListModel } from '../models/JobListModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { JobModel } from '../models/JobModel';
import { ModelResponse } from '../../core/services/ModelResponse';
import { LoadPagePayload } from '../../pillar/common/actions/LoadPagePayload';
import { REPOROCESS_JOB_SUBMISSION, ReprocessJobSubmissionAction } from '../store/actions/ReprocessJobSubmissionAction';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionError } from '../../pillar/common/actions/ActionError';
import { ReprocessJobSubmissionSuccessAction } from '../store/actions/ReprocessJobSubmissionSuccessAction';
import * as submissionActions from '../store/actions';
import { AdvancedFilterModel } from '../models/AdvancedFilterModel';
import { LoadFilteredPagePayload } from '../models/LoadFilteredPagePayload';
import { JobWorkSpacePageViewModel } from '../models/JobWorkSpacePageViewModel';

@Injectable()
export class JobsServiceEffects {
  @Effect()
  getJob$: Observable<Action> = this.actions$.ofType(pillarActions.getSelectionType<JobModel>(ModuleConfiguration.moduleName, JobModel))
    .map((a: pillarActions.GetSelectionAction<JobModel>) => a.payload)
    .switchMap((payload: { model: JobWorkSpacePageViewModel }) => this.jobsService.getJob(payload.model)
      .map((response: ModelResponse<JobModel>) => {
        if (response.hasError) {
          return new pillarActions.TileErrorsAction(ModuleConfiguration.moduleName, JobListModel, { errors: response.messages.map(m => m.value) });
        }
        return new pillarActions.GetSelectionSuccessAction(ModuleConfiguration.moduleName, JobModel, { model: response.model });
      }));
  @Effect()
  configureReporting$: Observable<Action> = this.actions$.ofType(REPOROCESS_JOB_SUBMISSION)
      .switchMap((action: ReprocessJobSubmissionAction) => this.jobsService.reprocessJobSubmission(action.payload.jobKey)
        .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<boolean>(error)))
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new ReprocessJobSubmissionSuccessAction({ jobKey: action.payload.jobKey });
      }));
  @Effect()
  cancelJobSubmission$: Observable<Action> = this.actions$.ofType(submissionActions.CANCEL_JOB_SUBMISSION)
      .switchMap((action: submissionActions.CancelJobSubmissionAction) => this.jobsService.cancelJobSubmission(action.payload.key, action.payload.jobKey)
      .catch((error: HttpErrorResponse) => Observable.of(new ModelResponse<boolean>(error)))
      .map((response: ModelResponse<boolean>) => {
        if (response.hasError) {
          return new ActionError(action, response.messages.map(m => m.value));
        }
        return new submissionActions.CancelJobSubmissionSuccessAction();
      }));

  @Effect()
  getJobList$: Observable<Action> = this.actions$.ofType(pillarActions.getQueryListType<JobListModel>(ModuleConfiguration.moduleName, JobListModel))
      .map((a: submissionActions.AdvancedFilterAction) => a.payload)
      .switchMap((payload: LoadFilteredPagePayload) => this.jobsService.getJobList(payload.page, payload.pageSize, payload.sort, payload.sortDirection, payload.searchTerm, payload.model)
      .map((response: QueryResponse<JobListModel>) => {
        if (response.hasError) {
          return new pillarActions.TileErrorsAction(ModuleConfiguration.moduleName, JobListModel, { errors: response.messages.map(m => m.value) });
        }
        return new pillarActions.QuerySuccessAction(ModuleConfiguration.moduleName, JobListModel, { items: response.items, totalCount: response.totalCount });
      }));
  constructor(
    private jobsService: JobsService,
    private actions$: Actions
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/submission/services/JobsService.effects.ts